import { handleResponse } from "utils/utils";
import { authService } from "services";

export const paymentTypesService = {
    getAll,
    getById,
    add,
    update,
    remove,
};

// get payment types
function getAll(options) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    let query = '?sort=+name';

    if (options) {
        let { q } = options;

        if (q !== undefined)
            query += "&q=" + q;
    }

    return fetch(`${global.BASE_API}payment-types${query}`, requestOptions).then(handleResponse);
}

// get payment type by id
function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    return fetch(`${global.BASE_API}payment-types/${id}`, requestOptions).then(handleResponse);
}

// add new payment type
function add(paymentType) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(paymentType)
    };

    return fetch(`${global.BASE_API}payment-types/`, requestOptions).then(handleResponse);
}

// update payment type
function update(paymentType) {
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(paymentType)
    };

    return fetch(`${global.BASE_API}payment-types/${paymentType.id}`, requestOptions).then(handleResponse);
}

// remove payment type
function remove(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    return fetch(`${global.BASE_API}payment-types/${id}`, requestOptions).then(handleResponse);
}
